import { h, Component } from 'preact';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Icon from '../../Global/Icon';
import Text from '../../Global/Text';
import Trans from '../../Global/Translation';

// Utils
import { actionHandler } from '../../../utilities/form/formUtils';
import { checkConditions } from '../../../utilities/package/packageUtils';
import { translateName } from '../../../utilities/common';
import { sendTrygTealium } from '../../../utilities/tracking';

class RecommendationSlider extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.sendTealium = this.sendTealium.bind(this);
  }
  next(currentSlide) {
    const currentSlideIndex = currentSlide.indexOfCurrentSlide;
    const currentSlideProduct = currentSlide.products[currentSlideIndex];
    const newTrackingStepNo = currentSlide.productDetails[currentSlideProduct].trackingStepNo;
    this.state.isTrackingSent = false;
    this.sendTealium(newTrackingStepNo, currentSlide.userData, currentSlide.translations);
  }
  previous() {
    this.slider.slickPrev();
  }
  sendTealium(trackStepNo, userData, translations) {
    if (trackStepNo && !this.state.isTrackingSent) {
      sendTrygTealium(trackStepNo, userData, translations);
      this.state.isTrackingSent = true;
    }
  }
  render() {
    const {
      bodyClass,
      label,
      actions,
      dispatch,
      values,
      userData,
      setValues,
      translations,
      productDetails,
    } = this.props;
    const { recommendation, initialSlide, questionaries } = userData;
    let products = [];
    products = Object.keys(recommendation).map((product) => {
      return `${product}`;
    });
    const initialSliderIndex = products.indexOf(initialSlide);
    if (initialSliderIndex !== '') {
      const newTrackingStepNo = productDetails[initialSlide].trackingStepNo;
      this.sendTealium(newTrackingStepNo, userData, translations);
    }
    const productCount = products.length;
    const bodyClasses = `text__body ${bodyClass} slide-count-${productCount}`;
    const arrowPrevClasses = 'prev-slick-arrow';
    const arrowNextClasses = 'next-slick-arrow';
    const paginationClasses = 'slick-pagination slide-bottom';
    const topCoverage = (coverage) => {
      const percentage = coverage.prevalence;
      const percentageVal = percentage.toString();
      const coverageStyle = {
        width: `${percentage}%`,
      };
      return (
        <div className="products-overview-coverage--percentage-outer">
          <div className="products-overview-coverage--percentage-width">
            <div className="products-overview-coverage--percentage-text" style={coverageStyle}>
              <Text value={coverage.name} component="span" />
            </div>
          </div>
          <span className="products-overview-coverage--percentage">{percentageVal}%</span>
        </div>
      );
    };
    const coverageName = (coverageNames, coverages, isMobile) => {
      const covName = coverageNames.name;
      const covVariantHouse = coverageNames.variant === 'activeIcon';
      let covIcon;
      const covPercentage = coverages;
      if (covVariantHouse) {
        Object.keys(coverageNames.iconHouse)
          .forEach(key => {
            if (checkConditions(coverageNames.iconHouse[key].conditions, userData)) {
              covIcon = coverageNames.iconHouse[key].icon;
            }
          });
      } else {
        covIcon = coverageNames.icon;
      }
      const covVariant = coverageNames.variant === 'dynamicIcon';
      let dynamicHeight = {};
      if (covVariant) {
        dynamicHeight = {
          height: `${covPercentage[0].prevalence / 1.16}px`,
        };
      }
      return (
        <div className="products-overview-coverage--outer">
          <div className="products-overview-coverage--inner">
            <div className="products-overview-coverage-icon--align">
              <Icon icon={covIcon} />
              {covVariant &&
                <div className="coverage__dynamic-percentage" style={dynamicHeight}>{covPercentage[0].prevalence}%</div>
              }
              {covVariantHouse &&
                <div className="coverage__dynamic-percentage-house" style={dynamicHeight}>{covPercentage[0].prevalence}%</div>
              }
            </div>
            <Text value={covName} component="span" />
          </div>
        </div>
      );
    };
    const settings = {
      dots: true,
      infinite: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      draggable: true,
      initialSlide: initialSliderIndex,
      afterChange: (indexOfCurrentSlide) => {
        this.next({
          indexOfCurrentSlide,
          products,
          productDetails,
          userData,
          translations,
        });
      },
      nextArrow: (
        <div>
          <div className={arrowNextClasses}>
            <Icon icon="sliderrightarrow" />
          </div>
        </div>
      ),
      prevArrow: (
        <div>
          <div className={arrowPrevClasses}>
            <Icon icon="sliderleftarrow" />
          </div>
        </div>
      ),
      appendDots: dots => (
        <div>
          <ul className={paginationClasses}> {dots} </ul>
        </div>
      ),
      customPaging: i => (
        <div>
          <Trans value={`${products[i]}-product-name-mobile`} />
        </div>
      ),
    };
    return (
      <div className={bodyClasses}>
        <div className="section--container">
          <Slider ref={c => (this.slider = c)} {...settings}>
            {Object.keys(recommendation).map((productName) => {
              const { product, coverages } = recommendation[productName];
              const productDetailsTitle = productDetails[productName].title;
              const productDetailsDesc = productDetails[productName].desc;
              const productDetailsCovTitle = productDetails[productName].coverageTitle;
              const iconName = productDetails[productName].icon;
              const fromIcon = productDetails[productName].iconFrom;
              const showPercentage = productDetails[productName].variant === 'showPercentage';
              let iconNameDisplay;
              switch (fromIcon) {
                case 'questionaries': {
                  const iconDisplay = questionaries && questionaries.filter(item => {
                    return item.id === iconName;
                  });
                  iconNameDisplay = iconDisplay && iconDisplay[0].value;
                  break;
                }

                case 'propertyTypeHousehold': {
                  iconNameDisplay = `${userData[iconName]}Household`;
                  break;
                }

                default:
                  iconNameDisplay = userData[iconName];
              }
              const iconNameTranslate = translateName(iconNameDisplay);
              return (
                <div data-title={product} className={`slider__${product}--outer slider__product--outer`} >
                  <div className={`${product} slider__left-section`}>
                    <Text value={productDetailsTitle} className="products-overview-slider-header" component="h2" />
                    <Text value={productDetailsDesc} className="product__desc" component="p" />
                    <Text value={productDetailsCovTitle} className="product__coverage-heading" component="p" />
                    {showPercentage && coverages.slice(0, 3).map(coverage => {
                      return topCoverage(coverage);
                    })}
                    {!showPercentage &&
                      <div>
                        <MediaQuery minWidth={768}>
                          <div>
                            {productDetails[productName].coverageList.map(name => {
                              return coverageName(name, coverages, false);
                            })}
                          </div>
                        </MediaQuery>
                        <MediaQuery maxWidth={767}>
                          <div>
                            {productDetails[productName].coverageList.map(name => {
                              return coverageName(name, coverages, true);
                            })}
                          </div>
                        </MediaQuery>
                      </div>
                    }
                  </div>
                  <div className="slider__right-section">
                    {iconNameDisplay &&
                      <Icon className={iconNameTranslate} icon={iconNameDisplay.replace(/[ ,]/g, '')} fill="black" businessUnitName={userData.businessUnitName} />
                    }
                  </div>
                </div>
              );
            })
            }
          </Slider>
        </div>
      </div>
    );
  }
}

export default RecommendationSlider;

RecommendationSlider.defaultProps = {
  body: null,
  bodyClass: '',
  label: '',
  actions: [],
  values: null,
  productDetails: null,
};

RecommendationSlider.propTypes = {
  body: PropTypes.string,
  bodyClass: PropTypes.string,
  label: PropTypes.string,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object,
  setValues: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  productDetails: PropTypes.array,
  translations: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Steps/General/RecommendationSlider.jsx